export default {
    primary: '#3f51b5',
    secondary: 'rgb(255, 8, 123)',
    bright: '#FBFEF9',
    dark: '#222222'
}